export default "__VITE_ASSET__jVUIy$vFv2GI5303UshewA__"